import type { ErrorBoundaryContextType } from 'react-error-boundary';

import { ErrorPage } from '@/features/error-page';

type ErrorRouteProps = {
  error?: ErrorBoundaryContextType['error'];
  onReset?: () => void;
};

const ErrorRoute = ({ error, onReset }: ErrorRouteProps) => (
  <ErrorPage error={error} onReset={onReset} />
);

export { ErrorRoute as Error };
